@if (isNameNotDefault()) {
    <div>{{ surname() }}</div>
} @else {
    <div>
        @switch (type()) {
            @case (DeviceTypeEnum.PLAY_MAX) {
                <span>PLAY</span><span class="yellow">Max</span>
            }
            @case (DeviceTypeEnum.CITY) {
                <span>CITY</span>
            }
            @case (DeviceTypeEnum.PLAY) {
                <span>PLAY</span><span class="yellow">2</span>
            }
            @case (DeviceTypeEnum.STOREY) {
                <span>STOREY</span>
            }
            @case (DeviceTypeEnum.STREAM_CONNECT) {
                <span>CONNECT</span>
            }
            @case (DeviceTypeEnum.STREAM_METER) {
                <span>METER</span>
            }
            @case (DeviceTypeEnum.ERL) {
                <span>LINKY</span>
            }
            @case (DeviceTypeEnum.ERL_GEN2) {
                <span>LINK</span>
            }
            @case (DeviceTypeEnum.LEGRAND_CONTACTOR) {
                <span>TAP</span>
            }
        }
    </div>
}
